<template>
  <v-dialog
    transition="slide-x-transition"
    content-class="custom-dialog"
    v-model="showDialog"
    scrollable
    @input="onClose"
    width="700"
  >
    <v-card>
      <!-- Header -->
      <div
        style="width: 100%; padding-left: 16px; padding-right: 16px; position: relative; box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.06); border-bottom: 1px #F2F2F2 solid; justify-content: flex-start; align-items: center;"
      >
        <div
          style="width: 100%; justify-content: flex-start; align-items: center; display: inline-flex"
        >
          <v-card-text
            style="flex: 1 1 0; color: #404040; font-size: 20px; font-family: Rubik; font-weight: 500; line-height: 36px; word-wrap: break-word"
          >
            Detalle de encuestas
          </v-card-text>

          <img
            src="@/assets/img/close.svg"
            type="button"
            @click="onClose"
            alt="Close"
          />
        </div>

        <div v-if="section?.filters" style="margin-top: -10px">
          <v-chip
            style="background-color: transparent;"
            v-for="(filter, i) in section.filters"
            :key="i"
            class="chip chip-header"
            variant="outlined"
          >
            {{ filter.selection.name }}
          </v-chip>
        </div>

        <v-container>
          <div style="display: flex; flex-direction: column">
            <div style="display: inline-flex; align-items: center">
              <img :src="require('@/assets/img/star.svg')" alt="" />

              <div class="rating-number ms-1">
                {{ section?.selectedReview?.rating }}
              </div>

              <v-progress-linear
                style="width: 100%; margin-left: 20px; margin-right: 10px"
                :value="section?.selectedReview?.percentage"
                height="12"
                :rounded="true"
              />

              <div
                class="rating-percentage"
                style="width: 50px; text-align: left"
              >
                {{ section?.selectedReview?.percentage }}%
              </div>

              <div
                class="review-count"
                style="text-align: end; min-width: 100px"
              >
                {{ section?.selectedReview?.count }}
                {{
                  section?.selectedReview?.count === 1
                    ? 'paciente'
                    : 'pacientes'
                }}
              </div>
            </div>
          </div>
        </v-container>
      </div>

      <!-- Body -->
      <div
        style="overflow-y: scroll; width: 100%; height: 500px; padding: 16px; left: 0; position: relative; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex;"
      >
        <div
          v-for="(reviewItem, index) in reviews"
          :key="index"
          @click="reviewItem.expanded = !reviewItem.expanded"
          style="width: 100%; border-bottom: 1px #F2F2F2 solid"
        >
          <div
            style="width: 100%; padding-top: 8px; padding-bottom: 8px; border-radius: 8px; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex"
          >
            <img
              :style="{
                transform: reviewItem.expanded
                  ? 'rotate(90deg)'
                  : 'rotate(0deg)',
              }"
              :src="require('@/assets/img/arrow-right.svg')"
              alt=""
              class="me-1"
            />

            <img
              style="width: 24px; height: 24px; border-radius: 30px; border: 1px #BFBFBF solid; object-fit: cover"
              :src="reviewItem.review.user_id.profile_picture"
              alt=""
            />

            <div
              style="flex: 1 1 0; height: 24px; justify-content: flex-start; align-items: center; gap: 8px; display: flex;"
            >
              <div
                style="align-self: stretch; color: #404040; font-size: 14px; font-family: Plus Jakarta Sans; font-weight: 600; line-height: 20px; word-wrap: break-word;"
              >
                {{ reviewItem.review.user_id.first_name ?? '' }}
                {{ reviewItem.review.user_id.last_name ?? '' }}
              </div>
            </div>
            <small style="color: #999; font-weight: 400;">
              {{ formatDate(reviewItem.review.createdAt) }}
            </small>
            <div
              style="padding: 2px 8px; background: white; border-radius: 8px; border: 1px #A6A6A6 solid; justify-content: center; align-items: center; gap: 8px; display: flex"
            >
              <div
                style="text-align: center; color: #737373; font-size: 14px; font-family: Plus Jakarta Sans; font-weight: 500; line-height: 20px; word-wrap: break-word"
              >
                {{ reviewItem.review.reason ?? '' }}
              </div>
            </div>
          </div>
          <div
            class="ps-4 pe-4 pt-2"
            v-if="reviewItem.expanded"
            style="width: 100%; color: #595959; font-size: 14px; font-family: Plus Jakarta Sans; font-weight: 600; line-height: 20px; word-wrap: break-word; padding-bottom: 10px"
          >
            {{ reviewItem.review.comment ?? '' }}<br />
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div
        class="web-pagination"
        style="width: 100%; height: 80px; padding-left: 16px; padding-right: 16px; position: relative; box-shadow: -2px -4px 8px rgba(0, 0, 0, 0.06); border-top: 1px #F2F2F2 solid; justify-content: center; align-items: center; display: flex;"
      >
        <!--paginas-->
        <v-pagination
          :length="pageConfig.pages"
          :circle="true"
          color="#f48020"
          navigationColor="#f48020"
          navigationTextColor="white"
          v-model="pageConfig.page"
          @input="loadReviews"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.title {
  color: #404040;
  font-size: 16px;
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
}

.chip-header {
  color: #737373;
  font-size: 14px;
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  word-wrap: break-word;
}

.rating-number {
  color: #595959;
  font-size: 15px;
  font-family: Rubik;
  font-weight: 500;
  line-height: 26px;
  word-wrap: break-word;
}

.review-count {
  color: #595959;
  font-size: 14px;
  font-family: Rubik;
  font-weight: 500;
  line-height: 26.18px;
  word-wrap: break-word;
}

.rating-percentage {
  color: #737373;
  font-size: 12px;
  font-family: Rubik;
  font-weight: 500;
  line-height: 17.45px;
  word-wrap: break-word;
}
</style>

<script>
import Pagination from 'vue-pagination-2';
import { getSurveyDetail } from '@/store/modules/metrics';

export default {
  name: 'ModalSurveyDetail',
  // eslint-disable-next-line vue/no-unused-components
  components: { Pagination },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    section: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    pageConfig: { page: 1, pages: 0 },
    reviews: [],
  }),

  created() {},

  watch: {
    section(val) {
      this.value = val;

      if (this.section?.type === 'surveys') {
        this.pageConfig.page = 1;
        this.loadReviews();
      }
    },
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    loadReviews() {
      this.reviews = [];
      const request = {
        professional_id: null,
        speciality_id: null,
        month: null,
        year: null,
        patient_status: null,
        appointment_session: null,
        page: this.pageConfig.page,
        rating: null,
      };

      if (this.section?.filters) {
        for (let filter of this.section.filters) {
          switch (filter.type) {
            case 'appointment_session':
              request.appointment_session = filter.selection.value;
              break;

            case 'speciality':
              request.speciality_id = filter.selection.id;
              break;

            case 'professional':
              request.professional_id = filter.selection.id;
              break;

            case 'patient_status':
              request.patient_status = filter.selection.value;
              break;

            case 'month':
              request.month = filter.selection.value;
              break;

            case 'year':
              request.year = filter.selection.value;
              break;
          }
        }
      }

      if (this.section.selectedReview)
        request.rating = this.section.selectedReview.rating;

      getSurveyDetail(request, true)
        .then((response) => {
          this.pageConfig.pages = parseInt(response.headers.pages);

          response.data.forEach((review) => {
            this.reviews.push({ review: review, expanded: false });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-AR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
  },
};
</script>
